import * as  moment from 'moment';
import { AppConstants } from 'src/app/common/enum/app.constants';
import { EnumTipoConsultaOptimizado } from 'src/app/common/enum/TipoPersona.enum';

export class BuscarCasos {
    public Nombre: string;
    public SNombre: string;
    public ApellidoPaterno: string;
    public ApellidoMaterno: string;
    public FechaInicial: string;
    public FechaFinal: string;
    public AlertaId: number;
    public NoCaso: number;
    public NoCasoBuzon: number;
    public Dictaminado: number;
    public Reportado: number;
    public Comite: number;
    public TipoCaso: number;
    public Pagina: number;
    public FechaRegistro: string;
    public Dictamen: string;
    public ClienteId: string;
    public RFC: string;
    //public Detalle: string;

    public BatchNumber: number;
    public BatchSize : number;
    public TipoConsulta : number;
    public EsReportar:number;
    public casos:[];

    constructor(){
        const FORMATO_SALIDA = 'YYYY-MM-DD';
        const FORMATO_ENTRADA = 'YYYY-MM-DDTHH:mm:ss Z';
        const fechainicial = moment(new Date(new Date().getFullYear(), new Date().getMonth(), 1), FORMATO_ENTRADA);
        const fechafinal = moment(new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0), FORMATO_ENTRADA);
        const fecharegistro = moment(new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0), FORMATO_ENTRADA);
        this.FechaInicial = fechainicial.format(FORMATO_SALIDA);
        this.FechaFinal = fechafinal.format(FORMATO_SALIDA);
        this.FechaRegistro = fecharegistro.format(FORMATO_SALIDA);
        this.Pagina = 1;
        this.AlertaId = -1;
        this.Dictaminado = 2;
        this.Reportado = 2;
        this.TipoCaso = 0;
        this.Comite = 0;
        this.NoCaso =0;
        this.Nombre = '';
        this.SNombre = '';
        this.ApellidoPaterno = '';
        this.ApellidoMaterno = '';
        this.Dictamen = '';
        this.ClienteId = '';
        this.RFC = '';
        this.BatchNumber = 1;
        this.BatchSize = (AppConstants.NUM_PAGES * AppConstants.ROWS_PER_PAGE) + 1;
        this.TipoConsulta = EnumTipoConsultaOptimizado.getDataGrid;
    }
}